import InfiniteTable, { ColumnsType } from '@/components/_common/InfiniteTable';
import {
  Supplier,
  SupplierCredits,
  SupplierTypeCredit,
} from '@/core/domain/people/Suppliers/Suppliers.types';
import formatterPrice from '@/utils/number/formatterPrice';
import { Space, Statistic } from 'antd';

interface Props {
  creditSupplier: SupplierCredits[];
  isLoading: boolean;
  hasNextPage?: boolean;
  fetchNextPage: () => void;
  supplier?: Supplier;
}

const SupplierCreditList: React.FC<Props> = ({
  creditSupplier,
  isLoading,
  hasNextPage,
  fetchNextPage,
  supplier,
}) => {
  const columns: ColumnsType<SupplierCredits> = [
    {
      dataIndex: 'companyName',
      title: 'Empresa',
      ellipsis: true,
      width: 200,
    },
    {
      dataIndex: 'purchaseCode',
      title: 'Código Compra',
      render: (value) => value || '-',
      ellipsis: true,
      width: 200,
    },
    {
      dataIndex: 'purchaseDocument',
      title: 'Número doc. compra',
      render: (value) => value || '-',
      ellipsis: true,
      width: 230,
    },
    {
      dataIndex: 'installmentPayableCode',
      title: 'Lanc. ref.',
      render: (value) => value || '-',
      ellipsis: true,
      width: 230,
    },
    {
      dataIndex: 'accountPayableCode',
      title: 'Conta',
      render: (value) => value || '-',
      ellipsis: true,
      width: 230,
    },
    {
      dataIndex: 'value',
      title: 'Valor Crédito',
      render: (value, row) => {
        if (row.type === SupplierTypeCredit.credit) {
          return (
            <div style={{ color: 'rgb(160, 206, 51)' }}>
              {formatterPrice(value)}
            </div>
          );
        }
      },
      ellipsis: true,
      width: 200,
    },
    {
      dataIndex: 'value',
      title: 'Valor Débito',
      render: (value, row) => {
        if (row.type === SupplierTypeCredit.debit) {
          return (
            <div style={{ color: 'rgb(207, 74, 29)' }}>
              {formatterPrice(value)}
            </div>
          );
        }
      },
      ellipsis: true,
      width: 200,
    },
  ];

  return (
    <>
      <InfiniteTable
        columns={columns}
        dataSource={creditSupplier}
        loading={isLoading}
        rowKey={(row) => row.id}
        pagination={false}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        style={{ textAlign: 'right' }}
        footer={() => (
          <Space>
            {/* <Statistic
              formatter={(value) =>
                formatterPrice(value)
              }
              title="Crédito gerado"
              value={0}
              valueStyle={{ color: 'black' }}
            />
            <Statistic
              formatter={(value) =>
                formatterPrice(value)
              }
              title="Crédito usado"
              value={0}
              valueStyle={{ color: 'rgb(207, 74, 29)' }}
            /> */}
            <Statistic
              formatter={(value) => formatterPrice(Number(value))}
              title="Crédito disponível"
              value={supplier?.credit ?? 0}
              valueStyle={{ color: '#a0ce33' }}
            />
          </Space>
        )}
      />
    </>
  );
};

export default SupplierCreditList;
